












































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF } from '@/interfaces';

@Component
export default class ProductsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public uploadDialogValue = false;

  public async downloadFilteredPriceList() {
    const data = {
      filter: this.getFilterValues(),
      sort: this.getSortString()
    };
    this.api.downloadAction(this.$store, '/products/export_pricelist', data);
  }

  public async uploadPriceList() {
    // Close dialog
    this.uploadDialogValue = false;
    // Start loading
    ((this.$refs.overview as unknown) as OverviewLayoutITF).tableLoading = true;
    // Upload prices
    await this.uploadFiles('', '/products', 'import_pricelist');
    // Reload table
    ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(
      true
    );
  }
}
